<template>
  <td :class="getCellClass(action, bill)">
    <v-tooltip v-if="action" top>
      <template v-slot:activator="{ on }">
        <div v-on="on"> <slot></slot> </div>
      </template>
      <span v-if="action">
        {{ action.statusMessage }}
      </span>
    </v-tooltip>
    <div v-else>
      <slot></slot>
    </div>
  </td>
</template>
<script>
export default {

  //model: {
  //	prop: ''
  //},
  props: {
    action: {
      type: Object,
      default: () => {},
    },
    bill: {
      type: Object,
      default: {},
    },
  },
  components: {},
  filters: {},
  data() {
    return {}
  },
  created() {},
  computed: {
    billActions() {
      return this.bill.billActions.map((ba) => {
        return {
          ...ba,
          statusDate: new Date(ba.statusDate),
        }
      })
    },
    govActions() {
      return this.billActions
        .filter((item) => {
          return item.location == 'Governor'
        })
        .sort((a, b) => b.statusDate - a.statusDate)
    },
    lsoActions() {
      return this.billActions
        .filter((item) => {
          return item.location == 'LSO'
        })
        .sort((a, b) => b.statusDate - a.statusDate)
    },
  },
  methods: {
    getCellClass(cell, bill) {
      var cellStatus =
        cell && cell.statusMessage ? cell.statusMessage.toLowerCase() : ''
      var cellClass = !!cell
        ? cellStatus.includes(':recommend') ||
          cellStatus.includes(':passed') ||
          cellStatus.includes('placed on general file') ||
          cellStatus.includes('governor signed') ||
          cellStatus.includes(`governor's signature`) ||
          cellStatus.includes('speaker signed') ||
          cellStatus.includes('president signed') ||
          cellStatus.includes('assigned number') ||
          cellStatus.includes('introduced')
          ? 'cell-green'
          : cellStatus.includes('did not consider') ||
            cellStatus.includes(':do pass failed') ||
            cellStatus.includes('died in committee') ||
            cellStatus.includes('withdrawn') ||
            cellStatus.includes('failed introduction') ||
            cellStatus.includes('vetoed') ||
            cellStatus.includes(':failed')
          ? 'cell-red'
          : 'cell-yellow'
        : ''
      if (
        this.bill.lastAction.toLowerCase().includes('postponed indefinitely')
      ) {
        cellClass = 'cell-yellow'
      }
      return cellClass
    },
  },
  watch: {},
}
</script>
<style scoped>
.cell-red {
  background-color: rgb(170, 51, 51);
}
.cell-green {
  background-color: rgb(44, 160, 44);
}
.cell-yellow {
  background-color: yellow;
}
td {
  width: 25px;
  height: 25px;
  border: 1px solid black;
  color: black !important;
}
</style>